document.addEventListener('DOMContentLoaded', function() {
  const banner = document.getElementById('Banner-template--24469158363459__image_banner');
  const buttonContainer = banner.querySelector('.banner__buttons');
  const beigeQuote = banner.querySelector('.banner__text');
  
  // 1. Dynamisch de breedte van de beige quote aanpassen aan de button
  function updateQuoteWidth() {
    if (buttonContainer && beigeQuote) {
      const button = buttonContainer.querySelector('.cta-button');
      if (button) {
        const buttonWidth = button.offsetWidth;
        beigeQuote.style.maxWidth = `${buttonWidth}px`;
      }
    }
  }
  
  // 2. Sticky button functionaliteit bij scrollen
  function handleScroll() {
    if (window.innerWidth >= 1400) { // Alleen voor brede schermen
      const bannerHeight = banner.offsetHeight;
      const scrollPos = window.scrollY;
      const targetPos = bannerHeight * 0.25; // 25% van banner
      
      if (scrollPos < targetPos) {
        // Button sticky op scherm
        buttonContainer.style.position = 'fixed';
        buttonContainer.style.bottom = '25vh';
      } else {
        // Button normaal in banner
        buttonContainer.style.position = 'absolute';
        buttonContainer.style.bottom = '25%';
      }
    } else {
      // Reset voor kleinere schermen
      buttonContainer.style.position = 'absolute';
      buttonContainer.style.bottom = '25%';
    }
  }
  
  // Voer functies uit bij laden en bij resize
  updateQuoteWidth();
  window.addEventListener('resize', updateQuoteWidth);
  window.addEventListener('scroll', handleScroll);
});
